angular.module('zc.zenclerkS')
  .factory('ZcsIncentive', zcsIncentive);

zcsIncentive.$inject = ['Api', 'Incentive'];
function zcsIncentive(Api, Incentive) {
  const MARGINAL_PROFIT_PERCENT_COUPON_MAP = [
    [0.00, [0.02, 0.03, 0.05]],
    [0.10, [0.03, 0.04, 0.05]],
    [0.15, [0.03, 0.05, 0.07]],
    [0.20, [0.05, 0.07, 0.10]],
    [0.25, [0.07, 0.10, 0.12]],
    [0.30, [0.10, 0.12, 0.15]],
    [0.35, [0.12, 0.15, 0.17]],
    [0.40, [0.15, 0.17, 0.20]],
    [1.00, [0.17, 0.20, 0.25]],
  ];

  const ZC_FEE_RATE = 0.05;
  const COUPON_BOTTOM_PRICE_RATE = 0.6;
  const COUPON_CENTER_MINIMUM_PRICE = 100;
  const PRICE_DOWN_PERCENT_SAFE_RATE = 0.6;
  const DEFAULT_PROFIT_PERCENT = 30;
  const DEFAULT_AVERAGE_CONVERSION_PRICE = 8000;

  const COUPON_PRICE_DOWN_MAP = [
    [100, 50],
    [200, 100],
    [300, 200],
    [500, 300],
    [1000, 500],
    [1500, 500],
    [2000, 500],
    [3000, 1000],
    [4000, 2000],
    [5000, 2500],
    [7500, 2500],
    [10000, 3000],
    [15000, 5000],
    [20000, 5000],
    [30000, 10000],
    [40000, 10000],
    [50000, 20000],
    [75000, 25000],
    [100000, 30000],
  ];


  class ZcsIncentive {
    static getDefaultProfitPercent() {
      return DEFAULT_PROFIT_PERCENT;
    }

    static getDefaultAverageConversionPrice() {
      return DEFAULT_AVERAGE_CONVERSION_PRICE;
    }

    static all(projectId, params) {
      return Incentive.all(projectId, params).then(incentives =>
        // sort latest first because we want to show only the latest created one
        // in the incentive list
        _.sortBy(incentives, d => -new Date(d.created_at))
      );
    }

    static versions(projectId, incentiveId) {
      return Api.get(`/api/projects/${projectId}/incentives/${incentiveId}/versions`)
        .then(res => res.data.versions);
    }

    // Get name for incentive
    static getName(incentive) {
      if(incentive.discount_type === 'price') {
        return `${incentive.coupon_code} ${incentive.discount_price}jpy`;
      } else if(incentive.discount_type === 'percent') {
        return `${incentive.coupon_code} ${incentive.discount_percent}%`;
      } else if(!incentive.discount_type && incentive.is_free_shipping) {
        return `${incentive.coupon_code} free shipping`;
      }
      return 'zcs_unfinished_incentive';
    }

    static getRecommendedFixedPriceCoupons(project) {
      const profitPercent = project.profit_percent || DEFAULT_PROFIT_PERCENT;
      const averageConversionPrice = project.average_conversion_price || DEFAULT_AVERAGE_CONVERSION_PRICE;
      let marginalProfitRate = profitPercent / 100;
      if(!marginalProfitRate) { marginalProfitRate = 0 }
      const couponBottomPrice = averageConversionPrice * COUPON_BOTTOM_PRICE_RATE;
      const priceDownPercent = (marginalProfitRate - ZC_FEE_RATE) * PRICE_DOWN_PERCENT_SAFE_RATE;

      let bottomPrice = couponBottomPrice * priceDownPercent;
      if(bottomPrice < COUPON_CENTER_MINIMUM_PRICE) {
        bottomPrice = COUPON_CENTER_MINIMUM_PRICE;
      }

      const map = _.findLast(COUPON_PRICE_DOWN_MAP, d => d[0] <= bottomPrice);
      if(!map) { return null }
      const [centerCouponDownPrice, diffPrice] = map;

      const upperCouponPrice = centerCouponDownPrice + diffPrice;
      const lowerCouponPrice = centerCouponDownPrice - diffPrice;
      return [lowerCouponPrice, centerCouponDownPrice, upperCouponPrice];
    }

    static getRecommendedPercentCoupons(project) {
      const profitPercent = project.profit_percent || DEFAULT_PROFIT_PERCENT;

      let marginalProfitRate = profitPercent / 100;
      if(!marginalProfitRate) { marginalProfitRate = 0 }
      return _.chain(MARGINAL_PROFIT_PERCENT_COUPON_MAP)
        .findLast(d => d[0] <= marginalProfitRate)
        .get(1) // get the next value
        .map(d => Math.round(d * 100)) // convert to percent
        .value();
    }

    static getMinimumPriceLimit(discountPrice) {
      if(!discountPrice) {
        return 0;
      }
      return discountPrice + 1;
    }
  }

  return ZcsIncentive;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/incentive.service.js